var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'progress'+(_vm.narrow ? ' narrow' : '')},[_c('div',{staticClass:"progress-inner",style:(("width: " + _vm.progress + "%"))}),_vm._v(" "),_c('div',{staticClass:"progress-label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }